const uuidGen = (): string => {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const arr = new Uint8Array(16);
    crypto.getRandomValues(arr);

    arr[6] = (arr[6] & 0x0f) | 0x40; // Set the 13th character to '4' (version 4)
    arr[8] = (arr[8] & 0x3f) | 0x80; // Set the 17th character to one of '8', '9', 'A', or 'B'

    return Array.from(arr)
      .map(b => b.toString(16).padStart(2, '0'))
      .join('')
      .replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
  } else {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
};

export default uuidGen;
